<template>
	<div class="am-timeline-inside"
		:class="{ 'is-idle': !init || !loaded }"
	>
	
		<div class="am-timeline-inside__background" :data-src="background">
		</div>

		<header class="am-timeline-inside__header">
			<am-text class="am-timeline-inside__title am-timeline-inside__title--third" type="title">
				<span>
					{{ title }}
				</span>
			</am-text>
		</header>

		<div class="am-timeline-inside__container">
			<simplebar id="custom-bar" class="padding-y-xl bg-contrast-lower timeline-holder dragscroll"  data-simplebar-auto-hide="false">
			<!-- <div class=" padding-y-xl bg-contrast-lower timeline-holder"> --> <!-- sidebar in component -->
				<div class="container-fluid max-width-adaptive-lg">
					<p class="scroll-text">Navegue pela nossa linha do tempo. Usando a barra ao lado ou o mouse.</p>
					<div class="v-timeline js-v-timeline timeline-inside" data-animation="on">
						<section v-for="item in timestamps" v-bind:key="item.id" class="v-timeline__section js-v-timeline__section">
							<div class="v-timeline__marker bg-contrast-high  border-3 border-contrast-lower" aria-hidden="true"></div>
					
							<div class="v-timeline__items-group">
								<div class="v-timeline__item bg padding-md radius-md shadow-xs">
									<div class="text-component ">
										<div v-b-modal="`modal-${item.id}`" class="img-hover">
											<img v-if="!item.url" class="img-hover-icon" :src="hover_icon" alt="">
											<img v-if="!item.url" class="img-hover-icon-light" :src="hover_icon" alt="">
											<img v-if="item.url" class="img-hover-icon" :src="hover_icon_2" alt="">
											<img v-if="item.url" class="img-hover-icon-light" :src="hover_icon_3" alt="">
											<img  v-bind:src="`${API}/storage/construction/${item.img}`" class="img-float" alt="Image description">
										</div>
										
											<div style="" class="data-float">
												<time class="v-timeline__date-value" datetime="2019-12-06T00:00">{{ item.date | formatDate}}</time>
												<h2>{{ item.title }}</h2>
										
												<p>{{ item.text }}</p>
											</div>

									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
			<!-- </div> -->
			</simplebar>
		</div>


		<!-- modais -->
		<b-modal v-for="item in timestamps" v-bind:key="item.id" :id="`modal-${item.id}`" size="xl" hide-footer hide-header >
			<div class="am-full-gallery__close" @click="$emit('close', $event)">
				<am-text type="button">
					Fechar
				</am-text>
				<am-button-icon block @click="$bvModal.hide(`modal-${item.id}`)"
					name="close"
				/>
			</div>
			<img v-if="!item.url" v-bind:src="`${API}/storage/construction/${item.img}`" 
			class="img-focus" 
			alt="Image description">
			<iframe  v-if="item.url" v-bind:src="`${item.url}`" class="video-focus" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		</b-modal>


  </div>
</template>
A
<script>
import AMButtonIcon from '@/components/molecules/AMButtonIcon'
import AMText from '@/components/atoms/AMText'
import { TweenMax, Power2 } from 'gsap/TweenMax'

/* import simplebar from 'simplebar-vue'; */
import simplebar from '@/components/atoms/AMScroll';

import 'simplebar/dist/simplebar.min.css';
/* new SimpleBar(document.getElementById('custom-bar'), {
	scrollbarMinSize: 25,
	scrollbarMinSize: 25
});
 */
export default {
	components: {
		'am-text': AMText,
		'am-button-icon': AMButtonIcon,
		'am-text': AMText,
		simplebar
	},

	props: {
		init: {
			type: Boolean,
			default: true
		},
		API:{
			type: String,
			default: process.env.API
		},

		title: {
			type: String,
			default: 'Acompanhe o andamento da obra'
		},
		text: {
			type: String,
			default: 'Adipisicing quo delectus deleniti aut quis, quasi totam? Vero adipisci nostrum itaque ducimus culpa?'
		},
		background: {
			type: String,
			default: 'https://placeimg.com/640/480/nature/grayscale'
		},
		image: {
			type: String,
			default: 'https://placeimg.com/640/480/nature'
		},
		hover_icon: {
			type: String,
			default: require('@/assets/images/timeline/icon.png')
		},
		hover_icon_2: {
			type: String,
			default: require('@/assets/images/timeline/icon-2.png')
		},
		hover_icon_3: {
			type: String,
			default: require('@/assets/images/timeline/icon-3.png')
		},
		items: {
			type: Array,
			default:[
				{
					id: 0, 
					date: '06 de dez 2019', 
					title: 'Funcionalidade de pagamento', 
					desc: 'Lorem Ipsum é simplesmente uma simulação de texto da indústria tipográfica e de impressos, e vem sendo utilizado'
				},
			],

		},
		timestamps: {
			type: Array,
			default:[
				{
					id: 0, 
					title: 'Funcionalidade de pagamento', 
					url: null, 
					category: 'teste', 
					img: 'teste.jpeg',
					text: 'Lorem Ipsum é simplesmente uma simulação de texto da indústria tipográfica e de impressos, e vem sendo utilizado',
					date: '06 de dez 2019',
					created_at: '06 de dez 2019',
				},
			],

		}
	},
	
	data: () => ({
		loaded: false
	}),

	watch: {
		init(value) {
			if (value)
				this.onLoad()
		}
	},

	mounted() {
		if (this.init){
			this.onLoad()


		}
	},

	methods: {
		start() {
			// Background
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-timeline-inside__background'), 1.5, {
				y: '-200px',
				opacity: 0,
				ease: Power2.easeOutl
			})

			// Gallery
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-timeline-inside__image'), 2, {
				x: '30%',
				opacity: 0,
				ease: Power2.easeOut
			})

			// Titles
			TweenMax.staggerFrom(this.$el.querySelectorAll('.am-timeline-inside__title span'), 1.5, {
				delay: .2,
				y: '200px',
				ease: Power2.easeOut
			}, .2)
		},

		onLoad() {
			let images = this.$el.querySelectorAll('.am-timeline-inside__image, .am-timeline-inside__background')

			images.forEach((image, index) => {
				let img = new Image()

				img.src = image.dataset.src
				img.onload = () => {
					image.style.backgroundImage = `url(${img.src})`

					if (index + 1 == images.length) {
						this.loaded = true
						this.start()
					}
				}
			})
		}
	}

	
}


</script>

<style lang="scss">
.modal-dialog {
	margin: 0 !important;
	max-width: 100% !important;
	border-radius: 0 !important;
}
.modal-body{
	padding: 0 !important;
}
.modal-content{
	border-radius: 0 !important;
	height: 100vh;
}
.img-focus{
	width: 100%;
	height: calc(100vh - 76px);
	margin-top: 75px;
	object-fit: cover;
}
.video-focus{
	width: 100%;
	height: calc(99.4vh - 77px);
	margin-top: 75px;
}
.simplebar-scrollbar:before{
	/* background-position: center;
	background-repeat: no-repeat;
	background-size: cover; */
	background: transparent;

	opacity: 0;
}
.simplebar-scrollbar{
	/* height: 100px !important;
	margin-top: auto !important;
	margin-bottom: auto !important; */
	cursor: grab;
	/* background-color: #99887F; */
	background-image: url("../../../assets/images/scroll.png");
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	opacity: 1;
}
.simplebar-track{
	background-color: #E4E4E4;
	margin: 10px;
	margin-right: 88%;

	-webkit-box-shadow:inset 0px 0px 0px 4px white;
    -moz-box-shadow:inset 0px 0px 0px 4px white;
    box-shadow:inset 0px 0px 0px 4px white;
}
/* -------------------------------- 

File#: _1_vertical-timeline
Title: Vertical Timeline
Descr: A vertical timeline used to display a sequence of events/steps
Usage: codyhouse.co/license

-------------------------------- */
:root {
  --v-timeline-marker-size: 22px; // dot indicator size
  --v-timeline-track-width: 2px; // vertical track (line) width
  --v-timeline-triangle-size: 12px; // triangle indicator size
  --v-timeline-sections-gap: var(--space-lg); // gap between sections (section = marker + item/s)
  --v-timeline-items-gap: var(--space-sm); // gap between items (if there are more than one within same date)
}
.img-hover{
	-webkit-transition: all .4s ease-in-out;
	-moz-transition: all .4s ease-in-out;
	-o-transition: all .4s ease-in-out;
	transition: all .4s ease-in-out;

}
.timeline-holder{
	
	overflow: auto !important;
    bottom: 0;
    position: sticky;
    max-height: calc(100vh - 310px);
}
.scroll-text{
	font-family: Flama;
	font-style: normal;
	font-weight: 300;
	font-size: 16px;
	line-height: 20px;

	color: #6E6E6E;

	max-width: 73px;

	text-align: right;
	position: fixed;
	padding-top: 60px;
}

@media (max-width: 540px)  {
	.timeline-holder{
		max-height: initial;
	}
	.timeline-inside{
		overflow: hidden;
	}
	.simplebar-track{
		display: none;
	}
	.scroll-text{
		display: none;
	}
}

.v-timeline {
  position: relative;
  padding: var(--space-lg) 0; // y padding

  &::before { // track
    content: '';
    position: absolute;
    top: 0;
    left: calc((var(--v-timeline-marker-size) - var(--v-timeline-track-width))*0.5);
    height: 100%;
    width: var(--v-timeline-track-width);
    background-color: rgba($color: #C4C4C4, $alpha: 1.0);
  }
}

.v-timeline__section {
  position: relative;
  display: flex;
  
  &:not(:last-of-type) {
    margin-bottom: var(--v-timeline-sections-gap); 
  }
}
.bg-contrast-high {
	background: #99887F;
    border: 4px solid white !important;
}
.v-timeline__marker {
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  position: relative;
  height: var(--v-timeline-marker-size);
  width: var(--v-timeline-marker-size);
  border-radius: 50%;
  margin-right: calc(var(--v-timeline-triangle-size) + var(--space-xxs));
}

.v-timeline__item {
  position: relative;
  top: calc(0.5 * var(--v-timeline-marker-size));
  flex-grow: 1;

  &::before { // triangle indicator
    content: '';
    position: absolute;
    top: 0;
    left: calc(-1 * var(--v-timeline-triangle-size) + 1px);
    height: var(--v-timeline-triangle-size);
    width: var(--v-timeline-triangle-size);
    background-color: inherit;
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%);
  }

  &:not(:last-child) {
    margin-bottom: var(--v-timeline-items-gap); // gap between timeline items
  }

  &:not(:first-child) {
    .v-timeline__date {
      display: none; // hide date if not first item
    }

    &::before {
      display: none; // hide triangle if not first item
    }
  }
}

.v-timeline__date-value { // date label
  color: #6F6F6F;
	font-family: Flama;
	font-style: normal;
	font-weight: 300;
	font-size: 16px;
	line-height: 19px;
  text-transform: uppercase;
  letter-spacing: 0.1em;

}


  .v-timeline::before { // track
    left: calc(50% - var(--v-timeline-track-width)/2);
  }

  .v-timeline__section {
	width: calc(50% + var(--v-timeline-marker-size)/2);
	
	h2{
		font-family: SanFrancisco;
		font-style: normal;
		font-weight: 100;
		font-size: 24px;
		line-height: 29px;
		color: #99887F;
	}
	p{
		color: #C4C4C4;
		font-family: Flama;
		font-style: normal;
		font-weight: 300;
		font-size: 16px;
		line-height: 20px;
	}
    
    &:nth-child(odd) {
      flex-direction: row-reverse;

      .v-timeline__marker {
        margin-right: 0;
        margin-left: calc(var(--v-timeline-triangle-size) + var(--space-xxs));
      }

      .v-timeline__item {
        &::before { // push triangle to the right
          left: auto;
          right: calc(-1 * var(--v-timeline-triangle-size) + 1px);
          transform: scaleX(-1);
        }

        &:first-child {
          border-top-right-radius: 0;
        }
      }

      .v-timeline__date {
        right: calc(-2 * (var(--v-timeline-triangle-size) + var(--space-xxs)) - var(--v-timeline-marker-size));
        transform: translateX(100%) translateY(-50%);
      }
    }
	.img-hover-icon{
		margin-top: 75px;
		margin-left: 75px;
		
		position: absolute;
		display: none;
	}
	.img-hover-icon-light{
		margin-top: 75px;
		margin-left: 75px;
		
		position: absolute;
	}

	.img-hover:hover{
		background: rgba(0, 0, 0, 0.4);
		cursor:pointer;
		.img-hover-icon{
			display: initial;
		}
		.img-hover-icon-light{
			display: none;
		}

	}
	.img-hover{
		float: right;
		margin: 0px 33px;
		background: rgba(0, 0, 0, 0); 
	}
	.img-hover{
		width: 190px;
		height: 190px;

		overflow: hidden;
	}
	.img-float{
		z-index: -1;
		position: relative;

		height: 100%;
		-webkit-transition: all .4s ease-in-out;
		-moz-transition: all .4s ease-in-out;
		-o-transition: all .4s ease-in-out;
		transition: all .4s ease-in-out;

	}
	.img-hover:hover .img-float{
		transform: scale(1.1);
	}
	
	.data-float{
		max-width: 200px;
		float: left;
	}
	@media (max-width: 1400px)  {
		.data-float{
			max-width: 190px;
		}
		.img-hover{
			margin: 0px 10px;
			width: 150px;
			height: 150px;
		}
		.img-float{
			

			
		}
		.img-hover-icon{
			margin-top: 55px;
			margin-left: 55px;
			
		}
		.img-hover-icon-light{
			margin-top: 55px;
			margin-left: 55px;
		}



	}
	@media (max-width: 940px)  {
		.data-float{
			float: initial;
			max-width: 100%;
			margin-left: 110px;
		}
		.img-hover{
			margin: 0px 10px;
			float: initial;
			margin-left: auto;
		}
		.img-float{
		}
	}
	@media (max-width: 540px)  {
		.data-float{
			margin-left: 0px;
		}
	}

	.text-component{
		text-align: right;
	}

    &:nth-child(even) {
	margin-left: auto;
	.img-hover{
		float: left;
	}
	.img-float{
		object-fit: cover;
	}
	.data-float{
		float: right;
	}
	@media (max-width: 940px)  {
		.data-float{
			margin-left: 0px;
		}
		/* .img-float{
			float: initial;
		} */
	}

	.text-component{
		text-align: left;
	}

      .v-timeline__item {
        &:first-child {
          border-top-left-radius: 0;
        }
      }

      .v-timeline__date {
        left: calc(-2 * (var(--v-timeline-triangle-size) + var(--space-xxs)) - var(--v-timeline-marker-size));
        transform: translateX(-100%) translateY(-50%);
      }
    }
  }

  .v-timeline__section--is-hidden {
    opacity: 0; // used in JS to hide section before the animation
  }

  .v-timeline__date {
    position: absolute;
    top: 0;
    white-space: nowrap;
  }

  // animations
  .js {
    .v-timeline[data-animation="on"] {
      .v-timeline__marker {
        opacity: 0;
        transform: scale(0.5);
        transition: transform .6s var(--ease-out), opacity .6s;
      }
  
      .v-timeline__item {
        opacity: 0;
        transition: transform .6s var(--ease-out), opacity .6s;
      }
  
      .v-timeline__section {
        &:nth-child(odd) .v-timeline__item {
          transform: translateX(-50px);
        }
  
        &:nth-child(even) .v-timeline__item {
          transform: translateX(50px);
        }
      }
  
      .v-timeline__section--animate {
        .v-timeline__item {
          transform: translateX(0) !important;
          opacity: 1;
        }
  
        .v-timeline__marker {
          transform: scale(1);
          opacity: 1;
        }
      }
    }
  }

// --icons
.v-timeline--icons {
  --v-timeline-marker-size: 3em;
}
	/* legacy styles */
	.open--modal{
		display: inline-block;
	    background: #99887F;
	    color: #fff;
	    font-family: Khand;
	    max-width: max-content;
	    padding: 10px 50px;
	    border-radius: 50px;
	    margin-top: 20px;
	    cursor: pointer;
	    font-size: 16px;
	    transition: 0.4s cubic-bezier(0.455, 0.03, 0.515, 0.955);
	    &:hover{
	    	opacity: 0.7
	    }
	}
.am-timeline-inside{
	background: white;
	position: relative;
	z-index: 10;
	transition: .3s $easeInOutQuad;
	&__container{
		display: flex;
		flex-flow: column;
		height: 100%;
		@include outer-container;
	}
	&__wrapper{
		flex: 1;
		@include grid-column(6);
	}
	&__background{
		position: absolute;
		top: 0px;
		left: 0;
		width: 100%;
		height: 100px;
		opacity: 1;
		z-index: -1;
		background-size: cover;
		background-position: center;
	}
	@media (max-width: 1400px)  {
		&__background{
			height: 200px;
		}
	}

	&__header{
		padding-top: 54px;
		margin-top: 60px;
		margin-bottom: 32px;
		padding-bottom: 100px;
		position: relative;
		    text-align: center;
	}
	&__title{
		line-height: 56px;
		overflow: hidden;
		span{
			word-wrap: break-word;
			display: block;
		}
		&--first{
			color: white;
		}
		&--second{
			color: #E3E3E3;
		}
		&--third{
		}
	}
		@include grid-media($tablet-grid) {
		&__header{
			/* margin-top: 34px;
			margin-bottom: 22px; */
		}
		&__header span{
			font-size: 44px;
			line-height: 44px;
		}
	}
	@include grid-media($smartphone-grid) {
		&__header{
			/* margin-top: 34px;
			margin-bottom: 22px; */
		}
		&__header span{
			font-size: 44px;
			line-height: 44px;
		}
	}

	&__text{
		opacity: .8;
		margin-bottom: 40px;
		transition: 1s $easeOutQuad 1.5s;
	}
	&__image{
		flex: 1;
		background-size: cover;
		background-position: center;
	}

	&.is-idle{
		opacity: 0;
		.am-timeline-inside{
			&__header{
				&:after{
					width: 0%;
					opacity: 0;
					transition: .5s $easeInOutQuad;
				}
			}
			&__text{
				transform: translateY(20px);
				opacity: 0;
				transition: .5s $easeInOutQuad;
			}
		}
	}

	@include grid-media($tablet-grid) {
		&__wrapper{
			@include grid-column(4);
		}
	}

	@include grid-media($desktop-grid) {
		display: block;
		&__image{
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 50%;
			&:after{
				content: "";
				display: block;
				padding-top: 60%;
			}
		}
		&__background{
			height: 200px;
		}
		&__header{
			&:after{
				width: 280px;
			}
		}
		&__title{
			line-height: 64px;
		}
		&__wrapper{
			@include grid-column(5);
		}
	}
}
</style>
